export default __webpack_public_path__ + "assets/icon-dark.03e46bb468238504b7179885566ad36f.png";